import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Skeleton from '../../../componentsv2/Skeleton';
import Layout from '../../../componentsv2/Layout';

export default function BankingPageSkeleton() {
  return (
    <Layout>
      <Grid container rowSpacing={2}>
        <Grid item xs={12}>
          <Grid container rowSpacing={1}>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" width="40%" height="36px" animation="wave" />
            </Grid>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" width="60%" height="21px" animation="wave" />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sx={{ display: 'flex', flex: 1 }}>
          <Box
            sx={{
              backgroundColor: '#fff',
              minHeight: '186px',
              borderRadius: '12px',
              padding: '1em 2em',
              width: '100%',
            }}
          >
            <Grid container rowSpacing={2}>
              <Grid item xs={12}>
                <Grid container rowSpacing={2}>
                  <Grid item xs={12}>
                    <Skeleton variant="rectangular" width="100%" height="88px" animation="wave" />
                  </Grid>
                  <Grid item xs={12}>
                    <Skeleton variant="text" width="100%" height="8px" animation="wave" />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container rowSpacing={2}>
                      <Grid item xs={6} md={8} sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Skeleton variant="text" width="20%" height="16px" animation="wave" />
                        <Skeleton variant="rectangular" width="25%" height="40px" animation="wave" />
                        <Skeleton variant="rectangular" width="40%" height="40px" animation="wave" />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={4}
                        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
                      >
                        <Box>
                          <Skeleton variant="rectangular" width={150} height="40px" animation="wave" />
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}
